exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Space{min-height:1px}.Space--horizontal{display:inline-block}", ""]);

// exports
